import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AuthGuard } from './services/guard/auth.guard';
import { PendingOrdersComponent } from './pages/pending-orders/pending-orders.component';
import { HomeComponent } from './pages/home/home.component';
import { CommonModule, DatePipe } from '@angular/common';


/** angular materials */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './AngularMaterialModules';
import { FooterComponent } from './components/footer/footer.component';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatRadioButton, MatRadioGroup, MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { StockComponent } from './pages/stock/stock.component';
import { PricesComponent } from './pages/prices/prices.component';
import { ActivityComponent } from './pages/activity/activity.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCurrencyFormatModule } from 'mat-currency-format';



/** ngx spinner */
import { NgxSpinnerModule } from 'ngx-spinner';
import { BalanceComponent } from './pages/balance/balance.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { HttpConfigInterceptor } from './services/interceptor/http.config.interceptor';
import { CreateVisitComponent } from './components/create-visit/create-visit.component';
import { VisitComponent } from './pages/visit/visit.component';
import { EditVisitComponent } from './components/edit-visit/edit-visit.component';
import { AlertComponent } from './components/common/alert/alert.component';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { RegisterDialogComponent } from './auth/register-dialog/register-dialog.component';
import { RemitosComponent } from './pages/remitos/remitos.component';
import { PlanillaPdfComponent } from './pages/planilla-pdf/planilla-pdf.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PendingOrdersComponent,
    FooterComponent,
    MainNavComponent,
    StockComponent,
    PricesComponent,
    ActivityComponent,
    BalanceComponent,
    DialogComponent,
    CreateVisitComponent,
    VisitComponent,
    EditVisitComponent,
    AlertComponent,
    RegisterDialogComponent,
    RemitosComponent,
    PlanillaPdfComponent
  ],
  imports: [
    CommonModule,           // 👈 ESTE ES EL QUE TE FALTA (para *ngIf, *ngFor)
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    LayoutModule,
    MatDatepickerModule,
    MatToolbarModule,
    MatRadioModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatCurrencyFormatModule
  ],
  providers: [
    AuthGuard,
    DatePipe,
    MatDatepickerModule,
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'primary' },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    { 
      provide: LocationStrategy, 
      useClass: PathLocationStrategy 
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogComponent, 
    CreateVisitComponent, 
    EditVisitComponent, 
    AlertComponent, 
    RegisterDialogComponent,
  ]
})
export class AppModule { }
